import { useContext, useEffect } from 'react';
import { DragCtx } from '../contexts';

/**
 * useDragEndReset — registers a reset function so any component can call
 * resetAll() to clear every drop-line in the tree synchronously inside
 * the drop/dragend handler.
 */
export function useDragEndReset(reset) {
  const ctx = useContext(DragCtx);
  useEffect(() => {
    ctx._resets.add(reset);
    return () => ctx._resets.delete(reset);
  }, [ctx, reset]);
}